import Vue from 'vue';

// bootstrap ui elements
import BootstrapVue from 'bootstrap-vue';

// bootstrap styles
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// our plug-ins
import ReportingApi from '@vigilantapps/vipro-cloud-reporting-api-client';

// views and other assets
import App from './App.vue';
import router from './router';
import store from './store';
import './site.scss';
import './pod.scss';

// commas
import FormatNumber from './plugins/filters-number';
Vue.use(FormatNumber)

Vue.config.productionTip = false;

// momentjs
Vue.use(require('vue-moment'));

// bootstrap ui elements
Vue.use(BootstrapVue);

// link to reporting api
Vue.use(ReportingApi, {
  endpoints: {
    landscape: 'https://us-central1-landscape-219208.cloudfunctions.net',
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
